import React, { useState, useEffect } from "react";
import { Box, Typography, Stack } from "@mui/material";
import SignupFunnelCard from "./SignupFunnelCard";
import { getSignupFunnel } from "../../api/region";
import { useSelector } from "react-redux";

const colorMap = {
  google: "#14AE5C",
  email: "#2E80DB",
  apple: "#EA4335",
};

const titleMap = {
  google: "Google Signup",
  email: "Email Signup",
  apple: "Apple Signup",
};

const SignupFunnelAnalysis = () => {
  const [signupFunnel, setSignupFunnel] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const { filter } = useSelector((state) => state);

  const fetchData = async () => {
    try {
      setIsLoading(true);
      const data = await getSignupFunnel(filter);
      setSignupFunnel(data || []);
      setIsLoading(false);
    } catch (err) {
      console.error("Error while loading user data", err);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [JSON.stringify(filter)]);

  return (
    <Box sx={{ boxShadow: "none", border: "1px solid #e6e6e6", borderRadius: "20px", p: 2 }}>
      <Typography fontWeight={500} sx={{ mb: 3, fontSize: "20px", color: "#3C4043" }}>
        Signup Funnel Analysis
      </Typography>
      <Stack direction={{ xs: "column", md: "row" }} spacing={2}>
        {signupFunnel.map((item) => {
          const total = item.TotalSignUps || 0;
          const completed = item.isCompletedCount || 0;
          const conversion = item.ConversionToPaid || 0;
          const abandoned = total - completed;

          return (
            <SignupFunnelCard
              key={item.SignUpType}
              title={titleMap[item.SignUpType] || item.SignUpType}
              mainValue={total}
              mainColor={colorMap[item.SignUpType] || "#999999"}
              percentage={item.profileCompletedRate || 0}
              avgCompletion="--" // if you calculate this later
              successRate={item.profileCompletedRate || 0}
              totalSignups={total.toLocaleString()}
              completed={completed.toLocaleString()}
              conversionActive={conversion}
              retentionRate={Math.round((conversion / (total || 1)) * 100)} // rough calc
              avgTimeFirstAction="--"
              abandoned={abandoned.toLocaleString()}
            />
          );
        })}
      </Stack>

      {(isLoading || !Boolean(signupFunnel?.length))
        && <Box sx={{ textAlign: 'center', py: 4 }}>
          <Typography variant="body1" color="text.secondary">
            {isLoading ? "Loading..." :"No data available"}
          </Typography>
        </Box>}
    </Box>
  );
};

export default SignupFunnelAnalysis;
